import * as uuid from 'uuid';
import { MaxLength, IsDefined, Validate } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model, $data } from 'src/core/services/data/JayDataContext';
import { ClientContactValidation} from 'src/core/customValidator/clientContactValidator';
import { PersonValidation} from 'src/core/customValidator/personValidator';
import { CompanyValidation} from 'src/core/customValidator/companyValidator';
import { ContactsValidation} from 'src/core/customValidator/contactsValidator';

export class ClientDataService extends DataService<typeof Model.Crm.Logic.ViewModels.ClientItem, Model.Crm.Logic.ViewModels.ClientItem, ClientItem> {
	protected map(entity: Model.Crm.Logic.ViewModels.ClientItem): ClientItem {
		return new ClientItemModel(entity);
	}

	static make(ctx?: any): ClientDataService {
		return new ClientDataService(ctx, ctx => ctx.Clients);
	}

	add(type: string, managedById: number, languageCode:string): Promise<ClientItem> {
		const entity = new Model.Crm.Logic.ViewModels.ClientItem();
		type = type.toLowerCase();

		entity.managedById = 1;
		entity.clientNumber = 'ClientNumber';
		entity.documentsLibraryId = uuid.v4();
		entity.type = type === 'person' ? 0 : 1;
		entity.managedById = managedById;
		entity.loginId = managedById;
		entity.status = 2;
		entity.priority = 2;
		entity.languageCode = languageCode;
		(<any>entity).dynamicProperties = {
			'contacts': [],
			'notes': [],
			[type]: {}
		};

		return this.create(() => entity);
	}
}

export class ClientItemModel extends EntityModel<Model.Crm.Logic.ViewModels.ClientItem, ClientItem> implements ClientItem {
	@property<ClientItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<ClientItemModel>(o => o.entity.clientNumber, (o, value) => o.entity.clientNumber = value)
	@IsDefined({ message: 'Client Number is empty' })
	@MaxLength(32)
	public clientNumber: string;

	@property<ClientItemModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<ClientItemModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
	@IsDefined({ message: 'Priority is empty' })
	public priority: number;

	@property<ClientItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

	@property<ClientItemModel>(o => o.entity.documentsLibraryId, (o, value) => o.entity.documentsLibraryId = value)
	public documentsLibraryId: string;

	@property<ClientItemModel>(o => o.entity.status, (o, value) => o.entity.status = value)
	@IsDefined({ message: 'Client Status is empty' })
	public status: number;

	@property<ClientItemModel>(o => o.entity.managedById, (o, value) => o.entity.managedById = value)
	@IsDefined({ message: 'Manage is empty' })
	public managedById: number;

	@property<ClientItemModel>(o => o.entity.loginId, (o, value) => o.entity.loginId = value)
	@IsDefined({ message: 'Login user is empty' })
	public loginId: number;

	@property<ClientItemModel>(o => o.entity.languageCode, (o, value) => o.entity.languageCode = value)
	@IsDefined({ message: 'Language Code is empty' })
	public languageCode: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(ClientContactValidation)
	@Validate(PersonValidation)
	@Validate(CompanyValidation)
	@Validate(ContactsValidation)
	public dynamicProperties: {};
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/form/client-form.data.ts